<template>
  <div v-if="type === ('resources' || 'collections') && resources.length === 0">
    No items found. End of results
  </div>
  <div v-if="type === 'resources'" ref="results" class="results-container">
    <MarketingItem
      v-for="(resource, index) in resources"
      :key="index"
      :num="index"
      :resource="resource"
      :display="'full'"
    />
  </div>
  <div v-if="type === 'uploads'" ref="results" class="results-container">
    <MarketingItem
      v-for="(resource, index) in uploads"
      :key="index"
      :type="'upload'"
      :num="index"
      :resource="resource"
      :display="'full'"
    />
  </div>
  <div v-if="type === 'collections'" class="collections-container">
    <CollectionGroup
      v-for="(collection, index) in collections"
      :key="index"
      :type="type"
      :collection="collection"
      :num="index"
    />
  </div>
  <div v-if="type === 'collectionItems'" ref="results" class="collections-container">
    <CreateItem
      v-for="(resource, index) in resources"
      :key="index"
      :num="index"
      :resource="resource"
      :display="'full'"
    />
  </div>
</template>

<script>
import MarketingItem from '@/components/libraries/search/MarketingItem';
import { mapStores } from 'pinia/dist/pinia';
import CollectionGroup from '@/components/libraries/search/collection/CollectionGroup';
import { useRMTStore } from '@/store/RMTStore';
import CreateItem from './search/collection/CreateItem.vue';

export default {
  name: 'SearchResults',
  components: {
    CollectionGroup,
    MarketingItem,
    CreateItem
  },
  props: [
    'type',
  ],
  data () {
    return {
      lastScroll: 0,
      currentScroll: 0,
      rmtLeft: null,
      header: null
    };
  },
  mounted () {

    if (!this.RMTStore.inCreateCollectionMode) {
      this.rmtLeft = document.getElementById('rmtLeft');
      this.header = document.getElementById('header');
      this.rmtLeft.addEventListener('scroll', this.onScroll);
    } else {
      this.rmtLeft = document.getElementById('collectionResults');
      this.header = document.getElementById('header');
      this.rmtLeft.addEventListener('scroll', this.onScroll);
    }
  },
  unmounted () {
    this.rmtLeft.removeEventListener('scroll', this.onScroll);
  },
  computed: {
    ...mapStores(useRMTStore),
    selectedMediaTypes () {
      return this.RMTStore.selectedMediaTypes;
    },
    resources () {
      return this.RMTStore.resources;
    },
    uploads () {
      return this.RMTStore.uploads;
    },
    collections () {
      return this.RMTStore.collections;
    },
    RMTSearchType () {
      return this.RMTStore.getSearchType;
    },
  },
  methods:{
    onScroll () {

      let h = this.header.getBoundingClientRect().height;
      this.lastScroll = this.currentScroll;
      this.currentScroll = this.rmtLeft.scrollTop;
      if (this.rmtLeft.scrollTop > 0) {
        this.header.style.top = -h + 'px';
      }
      if (this.lastScroll >= this.currentScroll) {
        this.header.style.transition = 'all .3s ease-out';
        this.header.style.top = '0';
      }
      this.handleScroll();
    },
    handleScroll () {

      if (this.RMTStore.searchType === 1 && !this.RMTStore.getPanelIsHidden && !this.RMTStore.inCreateCollectionMode) {
        // todo: this should load the addition assets within the collection
        return;
      }

      let scrolledPercentage = (100 * this.rmtLeft.scrollTop) / (this.rmtLeft.scrollHeight - this.rmtLeft.clientHeight);
      if (scrolledPercentage > 90 && !this.RMTStore.isLoading) {
        this.RMTStore.fetchPage();
      }

    },
  }
};
</script>

<style scoped>
.collections-holder {
  width: 100%;
  display: flex;
}
.results-container {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
}
.collections-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
@media (max-width: 1400px) {
  .results-container {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (max-width: 1280px) {
  .results-container {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 768px) {
  .results-container {
    grid-template-columns: repeat(3, 1fr);
  }
}
.placeholder-results {
  height: 2000px;
  width: 100%;
}
</style>